<template><span style="display: none"></span></template>
<script>
import EventBus from "@/event-bus";

export default {
    name: "Socket",
    props: {
        path: {
            required: true,
        },
        name: {
            required: true,
        },
        prefix: {
            default: '',
        }
    },
    data() {
        return {
            socket: null,
        }
    },
    methods: {
        connect() {
            const vm = this;

            if (vm.socket !== null) {
                vm.socket = null;
            }

            vm.socket = new WebSocket(`${location.protocol === 'http:' ? 'ws:' : 'wss:'}//${location.host}/websocket/${vm.path}`);

            vm.socket.onopen = function () {
                vm.$emit('onconnected')
                console.log(`${vm.name} socket connected "${vm.path}"`);
            };

            vm.socket.onclose = function () {

                console.log(`${vm.name} socket close`);

                vm.timer = setTimeout(() => {
                    console.log(`${vm.name} socket try reconnect`);
                    if (vm.socket !== null && (vm.socket.readyState === WebSocket.CLOSED || vm.socket.readyState === WebSocket.CLOSING)) {
                        vm.socket.onclose = null;
                        vm.connect();
                    }
                }, 30000)
            };

            vm.socket.onmessage = (e) => {
                const msg_data = JSON.parse(e.data);
                const type = vm.prefix ? vm.prefix + '_' + msg_data.type : msg_data.type;
                const data = msg_data.data;
                vm.$emit('onmessage', {type, data, msg_data})
            }

            vm.socket.onerror = (e) => {
                console.log(`${vm.name} socket connect error`, e);
                vm.socket.close()
            }
        }
    },
    mounted() {
        const vm = this;
        // if (this.socket.readyState === WebSocket.CLOSED) {
        //     this.connect()
        // }
        EventBus.$on('ondocumentvisible', () => {
            // const state = vm.socket ? {
            //     0: 'CONNECTING',
            //     1: 'OPEN',
            //     2: 'CLOSING',
            //     3: 'CLOSED'
            // }[vm.socket.readyState] : 'CLOSED'
            // console.log(`Socket "${vm.name}": ${state}`)
            if (vm.socket === null || vm.socket.readyState === WebSocket.CLOSED) {
                console.log('Document visible, reconnect Socket')
                vm.connect()
            }
        })
        // EventBus.$on('ondocumenthidden', () => {
        //     const state = vm.socket ? {
        //         0: 'CONNECTING',
        //         1: 'OPEN',
        //         2: 'CLOSING',
        //         3: 'CLOSED'
        //     }[vm.socket.readyState] : 'CLOSED'
        //     console.log(`Socket "${vm.name}": ${state}`)
        //     if (vm.socket !== null && vm.socket.readyState === WebSocket.OPEN) {
        //         console.log('Document hidden, disconnect Socket')
        //         vm.socket.onclose = null;
        //         vm.socket.close();
        //         console.log(`${vm.name} socket disconnect`);
        //         vm.socket = null;
        //     }
        // })
    },
    created() {
        this.connect();
    },
    beforeDestroy() {
        const vm = this;
        if (vm.socket !== null) {
            vm.socket.onclose = null;
            vm.socket.close();
            console.log(`${vm.name} socket destroy`);
            vm.socket = null;
        }
        EventBus.$off('ondocumentvisible')
        // EventBus.$off('ondocumenthidden')
    }
}
</script>